import { ENDPOINT } from '~/constants/endpoints';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { type MoveCompanyVariables } from './types';
import {
  zodMoveCompanyPathSchema,
  zodMoveCompanyPayloadSchema,
} from './validations';

/**
 * Moves a company to a target company account.
 *
 * @param variables - The company and target company-account IDs.
 * @param options - Additional request options, such as an abort signal.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Company/operation/move_company_vadmin_companies__company_id__move_post
 */
export async function moveCompany(
  { companyId, targetCompanyAccountId }: MoveCompanyVariables,
  options?: KyRequestOptions,
): Promise<void> {
  // A successful move returns 204 No Content, so there is no response body to validate.
  await vestigasApi.post(ENDPOINT.COMPANY.MOVE(companyId), {
    json: { targetCompanyAccountId },
    ...options,
    validate: {
      ...options?.validate,
      body: zodMoveCompanyPayloadSchema,
      pathSegments: zodMoveCompanyPathSchema,
    },
  });
}
